// functionalities Check

import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  Table,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
} from "@mui/material";
import QRCode from "react-qr-code";
import { BASE_URL, DOMAIN } from "../../global";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MuiTableCell from "@material-ui/core/TableCell";
import { Autocomplete } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import HistoryIcon from "@mui/icons-material/History";
import DataUsageIcon from "@mui/icons-material/DataUsage";

import "./certificate.css";
import "./certificateList.css";
import RenderStaticTables from "./renderTables";
import { viewCertificateGuide } from "./guide";
import { allSettings } from "../../utils/components/allSettings";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ErrorModal from "../../utils/components/errorModal";
import { ChangeCertificateStatus } from "./changeCertificateStatus";
import { accuracyFormat, parseRange } from "../../utils/components/accuracyandlcandrangesshow";
import { handleWithdrawApproval } from "./handleWithdrawApproval";
import { generatePDF } from "./printCertificate/printCertificate";
import { locationOptions } from "../../constants/srfConstants";
import CertificateDownloadPreview from "./certificatedownloadQRpreview";

const TableCell = withStyles({
  root: {
    border: "none",
    padding: "0px",
    margin: "0px",
    lineHeight: "1.32",
    fontSize: "11px",
    paddingLeft: "5px",
  },
})(MuiTableCell);

const useStyles = makeStyles({
  table: {
    border: "1px solid black",
    padding: "1px",
  },
  infoCell: {
    maxHeight: "5px",
  },
  innerCell: {
    padding: "0px",
    maxWidth: "40%",
  },
  formatedCell: {
    fontSize: "0.82em",
    padding: "0px",
    margin: "0px",
  },
  certificateCell: {
    fontSize: "0.82em",
    padding: "0px",
    margin: "0px",
    width: "20%",
  },
  sxPad: {
    padding: "5px",
  },
  addressCell: {
    width: "200px",
  },
});

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid cadetblue",
  padding: "18px",
  textAlign: "center",
  borderRadius: "5px",
};
const checkboxOptions = ["✔", "NA"];

export default function ViewCertificate(props) {
  const viewCertificateGuides = viewCertificateGuide();
  const printComponentRef = React.useRef();
  const classes = useStyles();
  const { certificateId: paramCertificateId } = useParams();
  let paramMultipleCertificateIdsArray=paramCertificateId?.split(",");
  const [finalCertificateId, setFinalCertificateId] = React.useState(paramMultipleCertificateIdsArray[0]);

  const certificateId = props.certificateIds || finalCertificateId;

  const [fetchCount, setFetchCount] = useState(0);
  const locationLink = useLocation();  
  const searchParams = new URLSearchParams(locationLink.search);
  const DownloadDraftparmas = searchParams.get("download");
  
  const [downloadingCount, setDownloadingCount] = useState(0);
  const [totalReadings, settotalReadings] = useState(0);
  const [instrument, setInstrument] = React.useState([]);
  const [configuration, setConfiguration] = React.useState({});
  const [clientName, setClientName] = React.useState("");
  const [clientID, setClientID] = React.useState(null);
  const [standardMasterArray, setStandardMasterArray] = React.useState([]);
  const [instrumentName, setInstrumentName] = React.useState("");
  const [requestedName, setRequestedName] = React.useState("");
  const [make, setMake] = React.useState("");
  const [calibrationProcedureNo, setCalibrationProcedureNo] =
    React.useState("");
  const [referenceStandards, setReferenceStandards] = React.useState("");
  const [lc, setLC] = React.useState("");
  const [dcNumber, setDcNumber] = React.useState("");
  const [ranges, setRanges] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [calibrationDate, setCalibrationDate] = React.useState(null);
  const [endcalibrationDate, setEndCalibrationDate] = React.useState(null);
  const [approvedDate, setApprovedDate] = React.useState(null);
  const [reviewedDate, setReviewedDate] = React.useState(null);
  const [signedDate, setSignedDate] = React.useState(null);
  const [witnessDate, setWitnessDate] = React.useState(null);
  const [dcDate, setDcDate] = React.useState(null);
  const [nextDueDate, setNextDueDate] = React.useState(null);
  const [receiptDate, setReceiptDate] = React.useState(null);
  const [poDate, setPoDate] = React.useState(null);
  const [dateOfIssue, setDateOfIssue] = React.useState("");
  const [calibrationFrequency, setCalibrationFrequency] = React.useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [showMessageScreen, setShowMessageScreen] = useState(null);

  const [calProcRefNo, setCalProcRefNo] = React.useState("");
  const [mfgNo, setMfgNo] = React.useState("");
  const [rangeDbData, setRangeData] = React.useState([]);
  // const [allRangeData, setRangeDataArray] = React.useState([]);
  const [specificValuesFromTable, setSpecificValuesFromTable] = React.useState(
    []
  );
  const [status, setStatus] = React.useState(-1);
  const [identificationNo, setIdentificationNo] = React.useState("");
  const [DUCID, setDUCID] = React.useState([]);
  const [calType, setCalType] = React.useState("");
  const [location, setLocation] = React.useState("");
  const [accuracy, setAccuracy] = React.useState("");
  const [filterRangeData, setFilterRangeData] = React.useState([]);
  const [serialNo, setSerialNo] = React.useState("");
  const [selectedStandards, setSelectedStandards] = React.useState("");
  const [ulrNumber, setUlrNumber] = React.useState(null);
  const [certificateNumber, setCertificateNumber] = React.useState("");
  const [serviceReqNumber, setServiceReqNumber] = React.useState("");
  const [certificateServiceReqNumber, setCertificateServiceReqNumber] = React.useState("");
  const [jobNumber, setJobNumber] = React.useState("");
  const [workOrderNumber, setWorkOrderNumber] = React.useState("");
  const [poNo, setPoNo] = React.useState(null);
  const [startTemp, setStartTemp] = React.useState("");
  const [endTemp, setEndTemp] = React.useState("");
  const [startHumidity, setStartHumidity] = React.useState("");
  const [endHumidity, setEndHumidity] = React.useState("");
  const [models, setModel] = React.useState("");
  const [sensorType, setSensorType] = React.useState("");
  const [ConOfDuc, setConOfDuc] = React.useState("");
  const [calPoint, setCalPoint] = React.useState("");
  const [calMethod, setCalMethod] = React.useState("");
  const [locationOfInstrument, setLocationOfInstrument] = React.useState("");
  const [srnNo, setSrnNo] = React.useState("");
  const [atmosphericPressure, setAtmosphericPressure] = React.useState("");
  const [disciplineName, setDisciplineName] = React.useState("");
  const [subGroup, setSubGroup] = React.useState("");
  const [showUncertainty , setShowUncertainty] = React.useState(0);
  const userType = localStorage.getItem("type");
  const [tableDisplayStatus, setTableDisplayStatus] = React.useState(1);
  const [settingList, setSettingList] = React.useState({});
  const [id, setId] = React.useState(-1);
  const [calibratedby, setCalibratedby] = React.useState("");
  const [approvedby, setApprovedby] = React.useState("");
  const [rejectedBy, setRejectedBy] = React.useState("");
  const [reviewedBy, setReviewedBy] = React.useState("");
  const [signedBy, setSignedBy] = React.useState("");
  const [witnessedBy, setWitnessedBy] = React.useState("");
  const user = [localStorage.getItem("id"), localStorage.getItem("userName")];
  const [letterHead, setLetterHead] = React.useState(DownloadDraftparmas ? false : true);
  const [draft, setDraft] = React.useState(DownloadDraftparmas ? true : false);
  const [scanCopy, setScanCopy] = React.useState(false);
  const [electronicSign, setElectronicSign] = React.useState(DownloadDraftparmas ? false : true);
  const [letterHeadCompnayType, setLetterHeadCompnayType] = React.useState(true);
  const [extraColumns, setExtraColumns] = React.useState([]);
  const [departmet, setDepartment] = React.useState("");
  const [input, setInput] = React.useState("");
  const [startPressure, setStartPressure] = React.useState("");
  const [endPressure, setendPressure] = React.useState("");
  const [type, setType] = React.useState("");
  const [depth, setDepth] = React.useState("");
  const [sensorDia, setSensorDia] = React.useState("");
  const [parameter, setParameter] = React.useState("");
  const [operatingrange, setOperatingrand] = React.useState("");
  const [revisionNumber, setRevisionNumber] = React.useState("");
  const [amendmnetHistory, setAmendmentHistory] = React.useState("");
  const [calibrationReason, setCalibrationReason] = React.useState(1);
  const [certificateDownloadCount, setCertificateDownloadCount] =
    React.useState({});
  const [isClientSettings, setIsClientSettings] = React.useState(false);
  const [isCompanyHierarchy, setIsCompanyHierarchy] = React.useState(false);
  const [complianceStatus, setComplianceStatus] = React.useState(null);
  const [compliance, setCompliance] = React.useState(false);
  const [lastModified, setLastModified] = React.useState("");
  const [showAmendment, setShowAmendment] = React.useState(false);
  const [instrumentId, setInstrumentId] = React.useState("");
  const [deletedTableIds, setDeletedTableIds] = React.useState("");
  const [rolesSettins, setRolesSettings] = React.useState("");
  const [calTypeSetting, setCalTypeSetting] = useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editAccess, setEditAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));
  const [pdfGenerated, setpdfGenerated] = React.useState(false);
  const [allocatedULRNo, setAllocatedULRNo] = useState(false);
  const [datasheetImages, setDatasheetImages] = useState("");
	  

  const [roles, setroles] = useState([]);
  const roles_ids = roles?.map((r) => Number(r.id));
  const [analysisSelectedOption, setAnalysisSelectedOption] = React.useState({
    accepted: "",
    calibrated: "",
    limitedUse: "",
    rejected: "",
    decsionRule1: "",
    decsionRule2: "",
    decsionRule13: "",
  });
  const [downloadPdfloading, setDownloadPdfloading] = React.useState(false);
  const [organizationLables, setOrganizationLables] = useState([]);
  const [errormodalIsOpen, setErrorModalIsOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [companyHierarchy, setCompanyHierarchy] = useState("");
  const [signImg, setSignImg] = React.useState(false);
  const [tableDivide, setTableDivide] = useState(false);
  const storedDeviceInfo = localStorage.getItem("deviceInfo");

  let footerSignSetting = {
    roles,
    calibratedby,
    approvedby,
    organizationLables,
    reviewedBy,
    clientName,
    signedBy,
    witnessedBy,
    signImg,
    instrument,
    address
  };

  let letterHeadAndElectronicAndDraft = {
    letterHead,
    draft,
    signImg,
    electronicSign,
    scanCopy,
    letterHeadCompnayType
  };
  
  let remarksCondition = {
    settingList,
    configuration,
    complianceStatus,
    amendmnetHistory,
    calTypeSetting,
    calibrationReason,
    analysisSelectedOption
  }

  let printProps = {
    certificateId,
    footerSignSetting,
    letterHeadAndElectronicAndDraft,
    remarksCondition,
    setDownloadPdfloading
  };

  const openErrorModal = (errorMessage, stackTrace, fileName) => {
    setErrorMessage({ errorMessage, stackTrace, fileName });
    setErrorModalIsOpen(true);
  };
  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
  };

  const convertToBooleanOrEmpty = (value) => {
    if (value === "1") return true;
    if (value === "") return "";
    return false;
  };
  
  const handleClose = () => {
    setModalOpen(false);
  };
  

  // api calls
  function fetchSettings() {
    axiosWithToken
      .get(BASE_URL + `settings?_where=(status,eq,1)`)
      .then((res) => {
        setFetchCount((prev)=> prev+1)
        let remark = null,
          complance = false,
          calTypeSetting = false,
          clientSetting = false,
          companyHierarchy = false,
          settings = res.data,
          _rolesSettings = {};
        let _settingList = {};
        settings.forEach((setting) => {
          if (setting?.keyName?.toLowerCase() === "remarks") {
            remark = setting?.value;
          } else if (
            setting?.keyName === "Compliance Status" &&
            setting?.value?.toLowerCase() === "true"
          ) {
            complance = true;
          } else if (
            setting?.keyName === "Client Settings" &&
            setting?.value?.toLowerCase() === "true"
          ) {
            clientSetting = true;
          } else if (
            setting?.keyName === "companyHierarchy" && 
            setting.status == 1
          ) {
            companyHierarchy = true;
          } else if (
            setting?.keyName === "Calibration Type" &&
            setting?.value?.toLowerCase() === "true"
          ) {
            calTypeSetting = true;
          }
          if (setting?.keyName?.startsWith("activeRole")) {
            _rolesSettings[setting?.keyName?.split("activeRole")[1]] = {
              name: setting?.value,
              id: setting?.keyName?.split("activeRole")[1],
            };
          }

          _settingList[setting?.keyName] = setting?.value;
        });
        _settingList["amendment"] = _settingList["amendment"]?.toLowerCase();
        // setSettingList(_settingList);
        setCompliance(complance);
        setIsClientSettings(clientSetting);
        setIsCompanyHierarchy(companyHierarchy);
        setCalTypeSetting(calTypeSetting);
        setRolesSettings(_rolesSettings);
      })
      .catch((err) => {
        console.error("Error fetching setting:", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "fetchSettings", "View Certificate")
              }
            >
              <u>Error: {err.message}</u>
            </h6>
          );
        }
      });
  }

  
  function downloadAuditlog(){
    let url = BASE_URL;
    let payload = {
      clientId: clientID,
      type: "certificates",
      identifier: certificateId,
      action: "download",
      userId: user[0],
      change_date: moment(new Date().toISOString()).format("YYYY-MM-DD HH:mm:ss")
    };
    axiosWithToken
      .post(url + `audit_log`, payload)
      .then((res) => res.data)
      .catch((err) => {
        console.log("certificate downloadAudit: ", err);
      });
  }

  function fetchCertificate() {
    let url = BASE_URL;
    let sqlQuery = {
      query: `select * from certificatesView where id = ${certificateId}`,
    };
    axiosWithToken
      .post(url + `dynamic`, sqlQuery)
      .then((res) => {
        // console.log(res.data);
        setFetchCount((prev)=> prev+1);
        if (res.data.length && res.data[0] != null) {
          setLastModified(res.data[0]?.lastModified);
          setStatus(res.data[0]?.status);
          setId(res.data[0]?.id);
          setClientName(res.data[0]?.billingName ? res.data[0]?.billingName : res.data[0]?.companyName);
          setClientID(res.data[0]?.clientId);
          setInstrumentName(res.data[0]?.instrumentName);
          settotalReadings(res.data[0]?.totalReadings);
          setMake(res.data[0]?.make);
          setModel(res.data[0]?.model);
          setLC(res.data[0]?.lc);
          setRanges(parseRange(res.data[0]?.ranges));
          setReferenceStandards(res.data[0]?.isaStandard ? res.data[0]?.isaStandard : res.data[0]?.referenceStandards);
          setTableDivide(res.data[0]?.tablePartition == 1 ? true : false);
          setSelectedStandards(res.data[0]?.additionalStandardIds?.split(","));
          setCalibrationProcedureNo(res.data[0]?.calibrationProcedureNo);
          setAddress(res.data[0]?.billing_address ? res.data[0]?.billing_address : res.data[0]?.client_address);
          setDcNumber(res.data[0]?.dcNumber);
          setUlrNumber(res.data[0]?.ULRNo);
          setAllocatedULRNo(res.data[0]?.allocatedULRNo);
          setCertificateNumber(res.data[0]?.certificateNumber);
          setDcDate(res.data[0]?.dcDate);
          setNextDueDate(res.data[0]?.nextDueDate);
          setReceiptDate(res.data[0]?.receiptDate);
          setCalProcRefNo(res.data[0]?.calProcRefNo);
          setMfgNo(res.data[0]?.mfgNo);
          setIdentificationNo(res.data[0]?.identificationNo);
          setDUCID(res.data[0]?.DUCID);
          setCalType(res.data[0]?.calibrationType);          
          setLocation(locationOptions.find(opt => opt.id == res.data[0]?.location)?.label || "");
          setAccuracy(res.data[0]?.accuracy);
          setSerialNo(res.data[0]?.serialNumber);
          setServiceReqNumber(res.data[0]?.serviceReqNumber);
          setCertificateServiceReqNumber(res.data[0]?.certificatesserviceReqNumber);
          setJobNumber(res.data[0]?.jobNumber);
          setWorkOrderNumber(res.data[0]?.workOrderNumber);
          setPoNo(res.data[0]?.poNumber);
          setPoDate(res.data[0]?.poDate);
          setStartTemp(res.data[0]?.startTemp);
          setEndTemp(res.data[0]?.endTemp);
          setStartHumidity(res.data[0]?.startHumidity);
          setEndHumidity(res.data[0]?.endHumidity);
          setDateOfIssue(res.data[0]?.dateOfIssue);
          setModel(res.data[0]?.model);
          setConOfDuc(res.data[0]?.ConOfDuc);
          setCalPoint(res.data[0]?.calPoint);
          setCalMethod(res.data[0]?.calMethod);
          setLocationOfInstrument(res.data[0]?.locationOfInstrument);
          setSrnNo(res.data[0]?.srnNo);
          setAtmosphericPressure(res.data[0]?.atmosphericPressure);
          setConfiguration(JSON.parse(res.data[0]?.configuration));
          setDisciplineName(res.data[0]?.name);
          setSubGroup(res.data[0]?.subGroup);
          setShowUncertainty(res.data[0]?.showUncertainty || 0);
          setSensorType(res.data[0]?.sensorType);
          setOperatingrand(parseRange(res.data[0]?.operatingRange));
          setDepartment(res.data[0]?.department);
          let extraEvvtries = res.data[0].extraColumns
            ? JSON.parse(res.data[0].extraColumns)
            : {};
          setInput(extraEvvtries["input"]);
          setDepth(extraEvvtries["Immersion Depth"]);
          setSensorDia(extraEvvtries["Sesnor Dia & Length"]);
          setParameter(extraEvvtries["Parameter Calibrated"]);
          setType(extraEvvtries["Type "]);
          setExtraColumns(
            Object.keys(extraEvvtries).length
              ? Object.entries(extraEvvtries)
              : []
          );
          setStartPressure(res.data[0].startPressure);
          setendPressure(res.data[0].endPressure);
          setCalibrationReason(res.data[0].calibrationReason);
          setInstrumentId(res.data[0]?.instrumentId);
          setDeletedTableIds(res.data[0]?.deletedTableIds);
          res.data[0]?.specificValues
            ? setSpecificValuesFromTable(res.data[0]?.specificValues.split(","))
            : setSpecificValuesFromTable([]);
          setTableDisplayStatus(res.data[0]?.tableDisplayStatus);
          setCompanyHierarchy(res.data[0]?.companyHierarchy);
          setDatasheetImages(res.data[0]?.datasheetImages);

          axiosWithToken
            .get(
              BASE_URL +
                `usersView?_where=(id,in${
                  res.data[0]?.calibratedby
                    ? `,${res.data[0]?.calibratedby}`
                    : "" || ""
                }${
                  res.data[0]?.approvedby
                    ? `,${res.data[0]?.approvedby}`
                    : "" || ""
                }${
                  res.data[0]?.rejectedBy
                    ? `,${res.data[0]?.rejectedBy}`
                    : "" || ""
                }${
                  res.data[0]?.reviewedBy
                    ? `,${res.data[0]?.reviewedBy}`
                    : "" || ""
                }${
                  res.data[0]?.signedBy ? `,${res.data[0]?.signedBy}` : "" || ""
                }${
                  res.data[0]?.witnessBy
                    ? `,${res.data[0]?.witnessBy}`
                    : "" || ""
                })`
            )
            .then((res2) => {
              setFetchCount((prev)=> prev+1);
              // Logic to remove _c and _u if xjoin if used
              // Update replace all if xjoin members are increased in future
              // let tmp = [...res.data];
              // tmp.map((e, i) =>
              //   Object.keys(e).map(
              //     (k) =>
              //       (res.data[i][k.replaceAll("_c", "").replaceAll("_u", "")] =
              //         e[k])
              //   )
              // );
              res2.data.map((e) => {
                if (e.id == res.data[0]?.calibratedby) {
                  setCalibratedby([
                    res.data[0]?.calibratedby,
                    e.userName,
                    e.id,
                    e.companyName,
                    res.data[0]?.calibrateddesignation,
                    e?.usersign,
                  ]);
                }
                if (e.id == res.data[0]?.approvedby)
                  setApprovedby([
                    res.data[0]?.approvedby,
                    e.userName,
                    e.id,
                    e.companyName,
                    res.data[0]?.approveddesignation,
                    e?.usersign,
                  ]);
                if (e.id == res.data[0]?.rejectedBy)
                  setRejectedBy([
                    res.data[0]?.rejectedBy,
                    e.userName,
                    e.id,
                    e.companyName,
                  ]);
                if (e.id == res.data[0]?.reviewedBy)
                  setReviewedBy([
                    res.data[0]?.reviewedBy,
                    e.userName,
                    e.id,
                    e.companyName,
                    e?.usersign,
                  ]);
                if (e.id == res.data[0]?.signedBy)
                  setSignedBy([
                    res.data[0]?.signedBy,
                    e.userName,
                    e.id,
                    e.companyName,
                    e?.usersign,
                  ]);
                if (e.id == res.data[0]?.witnessBy)
                  setWitnessedBy([
                    res.data[0]?.witnessBy,
                    e.userName,
                    e.id,
                    e.companyName,
                    e?.usersign,
                  ]);
              });
            });

          setCalibrationDate(res.data[0].calibrationDate);
          setApprovedDate(res.data[0]?.approvedDate);
          setReviewedDate(res.data[0]?.reviewedDate);
          setSignedDate(res.data[0]?.signedDate);
          setWitnessDate(res.data[0]?.witnessDate);
          setEndCalibrationDate(res.data[0]?.endCalibrationDate);

          setCalibrationFrequency(res.data[0]?.calFrequency == "Not Required" ? "-" : res.data[0]?.calFrequency == "Customer Defined" ? "Customer Defined" : res.data[0]?.calFrequency === "NA" ? "NA" : res.data[0]?.calFrequency);
          setRevisionNumber(res.data[0]?.revisionNumber);
          let tmpSplt = res.data[0]?.amendment
            ? res.data[0]?.amendment.split("||")
            : [];
          setAmendmentHistory(
            tmpSplt.filter((_, i) => i === tmpSplt.length - 1)
             ?.map(line => {
            const parts = line.split(",");
            return parts.length > 2 ? line.substring(0, line.lastIndexOf(",")) : line;
          })
          );
          setRequestedName(
            res.data[0]?.requestedname ? res.data[0]?.requestedname : ""
          );
          setComplianceStatus(res.data[0]?.complianceStatus);

          fetchInstrument(res.data[0]?.instrumentId);

          axiosWithToken
            .get(
              url +
                `datasheetStaticReadings?_where=(datasheetId,eq,${certificateId})`
            )
            .then((response) => {
              setFetchCount((prev)=> prev+1);
              if (response?.data) {
                let standardIds = response?.data
                  ?.map((e) => e.standardRanges)
                  .filter(Boolean);
                //  monitorDeviceRange add
                let monitorIds = response?.data
                  ?.map((e) => e.monitorDeviceRange)
                  .filter(Boolean);
                const selectedStandardIds = [];
                standardIds.forEach((str) => {
                  str.split(",").forEach((sub) => {
                    const num = parseInt(sub.split(":")[0]);
                    if (!selectedStandardIds.includes(num)) {
                      selectedStandardIds.push(num);
                    }
                  });
                });
                // ADD parsing logic for monitorDeviceRange
                monitorIds.forEach((str) => {
                  str.split(",").forEach((sub) => {
                    const num = parseInt(sub.split(":")[0]);
                    if (!selectedStandardIds.includes(num)) {
                      selectedStandardIds.push(num);
                    }
                  });
                });

                if (selectedStandardIds) {
                  let combineArray = [...new Set(selectedStandardIds)];
                  axiosWithToken
                    .get(url + `standards?_where=(id,in,${combineArray.toString()})~and(status,eq,1)`)
                    .then((res) => {
                      setStandardMasterArray(res.data)
                      setFetchCount((prev)=> prev+1)
                    })
                    .catch((err) => console.log(err));
                }
                setFetchCount((prev)=> prev+1)
              }
            })
            .catch((err) => console.log(err));

           

        }
      })
      .catch((err) => {
        console.log("certificate data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(
                  err.message,
                  "fetchCertificate",
                  "View Certificate"
                )
              }
            >
              <u>Error: {err.message}</u>
            </h6>
          );
        }
      });
  }

  function fetchInstrument(instrumentId) {
    let url = BASE_URL;
    axiosWithToken
      .get(url + `instruments?_where=(id,eq,${instrumentId})`)
      .then((res) => {
        setFetchCount((prev)=> prev+1);
        setInstrument(res.data);
      })
      .catch((err) => {
        console.log("certificate tables data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "fetchInstrument", "View Certificate")
              }
            >
              <u>Error: {err.message}</u>
            </h6>
          );
        }
      });
  }

  function certificateCount() {
    let data = {
      query: `SELECT * FROM certificateAnalytics WHERE certificateId = ${certificateId} `,
    };

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        // setFetchCount((prev)=> prev+1)
        setCertificateDownloadCount(res.data[0]);
      })
      .catch((err) => {
        console.log("certificateAnalytics tables data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(
                  err.message,
                  "certificateCount",
                  "View Certificate"
                )
              }
            >
              <u>Error: {err.message}</u>
            </h6>
          );
        }
      });
  }


  const hasClientSettingsFetched = React.useRef('');
  useEffect(() => {
    hasClientSettingsFetched.current = '';
  }, [certificateId]);

  useEffect(() => {
    // Only proceed if all required dependencies are available
    if (!clientID || !certificateNumber) {
      return;
    }
    // If company hierarchy is required but not yet available, wait
    if (isCompanyHierarchy && !companyHierarchy) {
      return;
    }
    // Create a unique key - only include companyHierarchy if it's actually being used
    const currentKey = `${clientID}-${certificateNumber}-${isCompanyHierarchy ? companyHierarchy : ''}`;

    // Prevent duplicate calls with same parameters
    if (hasClientSettingsFetched.current === currentKey) {
      return;
    }
    const fetchClientSetting = async () => {
      try {
      hasClientSettingsFetched.current = currentKey; // Set key before API call      
        const AllSettings = await allSettings(
          isClientSettings ? clientID : undefined,
          isClientSettings && isCompanyHierarchy ? companyHierarchy : undefined
        );
        let _settingList = {};
        AllSettings.forEach((setting) => {
          _settingList[setting?.keyName] = setting.value;
        });
        setSettingList(_settingList);

        const footerRoles = AllSettings?.filter(
          (el) =>
            el.keyName?.includes("activeRole") &&
            el.value !== "false" &&
            !el.keyName?.includes("_PossibleFields")
        )
          ?.map((item) => ({
            name: item.value,
            id: item.keyName.charAt(item.keyName.length - 1),
            label: item.value,
            key: item.keyName,
          }))
          ?.sort((a, b) => a.id - b.id);

        let OrgLables = footerRoles?.filter((el) => el.key.includes("Label"));
        let footerRoleFilter = footerRoles?.filter(
          (el) => !el.key.includes("Label")
        );

        setOrganizationLables(OrgLables);
        setroles(footerRoleFilter);
        setFetchCount((prev)=> prev+1);
      } catch (err) {
        console.error("Error fetching data:", err);
        hasClientSettingsFetched.current = ''; // Reset on error
        let trace = new Error().stack;
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, trace, "View Certificate")
              }
            >
              <u>Error: {err.message}</u>
            </h6>
          );
        }
      }
    };

    fetchClientSetting();
  }, [clientID, isClientSettings, companyHierarchy, isCompanyHierarchy, certificateNumber]);

  function getOpinionAndAnalysisList() {
    let url = BASE_URL;
    const payload = {
      query: `SELECT * FROM opinionAndAnalysis WHERE certificateId = ${certificateId}`,
    };
    axiosWithToken
      .post(url + "dynamic", payload)
      .then((res) => {
        if (res.data.length > 0) {
          setFetchCount((prev)=> prev+1);
          const parsedData = {
            ...res.data[0],
            accepted: convertToBooleanOrEmpty(res.data[0].accepted),
            limitedUse: convertToBooleanOrEmpty(res.data[0].limitedUse),
            calibrated: convertToBooleanOrEmpty(res.data[0].calibrated),
            rejected: convertToBooleanOrEmpty(res.data[0].rejected),
            decsionRule1: convertToBooleanOrEmpty(res.data[0].decsionRule1),
            decsionRule2: convertToBooleanOrEmpty(res.data[0].decsionRule2),
            decsionRule3: convertToBooleanOrEmpty(res.data[0].decsionRule3),
          };
          setAnalysisSelectedOption(parsedData);
        }
      })
      .catch((err) => {
        console.log("Something Went Wrong!");
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(
                  err.message,
                  "getOpinionAndAnalysisList",
                  "View Certificate"
                )
              }
            >
              <u>Error: {err.message}</u>
            </h6>
          );
        }
      });
  }

  useEffect(() => {
    fetchCertificate();
    fetchSettings();
    certificateCount();
    getOpinionAndAnalysisList();
  }, [finalCertificateId]);


  useEffect(() => {


    if (fetchCount > 6 && pdfGenerated && paramMultipleCertificateIdsArray.length > 1 && downloadingCount < paramMultipleCertificateIdsArray.length) {
     const timer = setTimeout(() => {
        generatePDF(printProps).then(() => {
          setFetchCount(0);
         if (downloadingCount+1 < paramMultipleCertificateIdsArray.length) {
            setFinalCertificateId(paramMultipleCertificateIdsArray[downloadingCount+1]);
          }
          setDownloadingCount((prev) => prev + 1);
          setCalibratedby("");
          // pdfGenerated = false;
        });
      }, 1000);
      // Cleanup function to clear the timeout if the component unmounts
      return () => clearTimeout(timer);
    }
  }, [certificateNumber, fetchCount, pdfGenerated]);


  useEffect(() => {
  if(paramMultipleCertificateIdsArray.length == 1){
  if (approvedby) {
    setDraft(false);
      setLetterHead(true);
      setSignImg(false);
      setElectronicSign(true);
    } else {
      setDraft(true);
      setLetterHead(false);
      setSignImg(false);
      setElectronicSign(false);      
    }
  }
  }, [approvedby]);

  const formatDateByClient = (date, time) => {
    if (!date || !moment(date).isValid()) {
      return "\u00A0"; // Return non-breaking space if date is invalid or empty
    }
    const dateFormat =
      settingList["Date format(word)"] &&
      settingList["Date format(word)"].toString().toLowerCase() === "true"
        ? "DD MMM YYYY"
        : "DD/MM/YYYY";

    if (time) {
      return moment(date).format(`${dateFormat}, HH:mm`);
    } else {
      return moment(date).format(dateFormat);
    }
  };

 const hasDownloadedRef = React.useRef(false);
  useEffect(() => {
    if(props.isPrint == true){
      setLetterHead(true);
      setElectronicSign(false);
      setSignImg(true);
      setDraft(false);
    }
    const dataReady =
      props.isPrint === true &&
      approvedby &&
      calibratedby &&
      certificateId &&
      footerSignSetting &&
      letterHeadAndElectronicAndDraft &&
      remarksCondition
      && roles?.length > 0 && clientID &&
      Object.keys(settingList).length > 0 &&
      organizationLables &&  // Check if organization labels are ready
      fetchCount >= 3;  // Ensure minimum API calls are completed (adjust number based on your needs)
    if (!dataReady && props.isPrint == true) {
      setShowMessageScreen("Certificate Is Not Approved.");
    }
    if (dataReady && !hasDownloadedRef.current) {
      hasDownloadedRef.current = true; // prevent multiple downloads
        if (paramMultipleCertificateIdsArray.length > 1) {
          setpdfGenerated(true);
        } else {
          // generatePDF(printProps);
          setPreviewOpen(true);
        }
    }
  }, [props.isPrint, approvedby, calibratedby, certificateId, footerSignSetting, letterHeadAndElectronicAndDraft, remarksCondition, certificateNumber, roles, clientID, settingList, organizationLables, fetchCount]);

  let ISendcalibrationDate  = endcalibrationDate ?  `${formatDateByClient(calibrationDate)} to ${formatDateByClient(endcalibrationDate)}` : formatDateByClient(calibrationDate);

  const printView = () => {
    return (
      // <>
      <div
        id="printOnly2"
        // style={{ pageBreakAfter: "always" }}
        ref={printComponentRef}
      >
        <table style={{ width: "100%" }}>
          <tbody className="page" >
            <tr>
              <td style={{ border: "none" }}>
                <div
                  className="content"
                  style={{
                    fontSize: "11px",
                    margin: "18px",
                    marginTop: "0px",
                    marginBottom: "0px",
                    padding: "2px 10px",
                    // border: "1px solid black",
                  }}
                >
                  <Table>
                    {customerDetailsTable()}
                   {otherDetails()}
                    {unitCalibrationDetails()}
                    <Table
                      className={classes.table}
                      style={{ marginBottom: "3px" }}
                    >
                      <TableRow>
                        <TableCell>
                          <b style={{fontFamily: "Times New Roman, serif",}}>Environmental Condition During Calibration: </b>
                        </TableCell>
                        <TableCell>
                          <span style={{fontFamily: "Times New Roman, serif",}}>
                            <span style={{ paddingRight: "10px",fontFamily: "Times New Roman, serif", }}>
                            Reference Standards :
                            </span>
                            {referenceStandards}
                          </span>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={{fontFamily: "Times New Roman, serif",}}>
                          <span style={{fontFamily: "Times New Roman, serif",}}>
                            <span style={{ paddingRight: "10px",fontFamily: "Times New Roman, serif", }}>
                            Temperature & Humidity :
                            </span>
                            {
                              (() => {
                                const parseNumericValue = (value) => parseFloat(value?.replace(/[^\d.-]/g, '')) || 0;

                                const avgTemp = ((parseNumericValue(startTemp) + parseNumericValue(endTemp)) / 2).toFixed(1);
                                const avgHumidity = ((parseNumericValue(startHumidity) + parseNumericValue(endHumidity)) / 2).toFixed(1);

                                return `${avgTemp} °C & ${avgHumidity} %RH`;
                              })()
                            }
                            {/* {startTemp?.includes("°C")
                              ? startTemp?.replace("#", " ")
                              : startTemp + " °C"} & {startHumidity?.includes("%RH")
                              ? startHumidity?.replace("#", " ")
                              : startHumidity + "  %RH"} */}
                          </span>
                        </TableCell>
                        <TableCell>
                          <span style={{fontFamily: "Times New Roman, serif",}}>
                            <span style={{ paddingRight: "10px" ,fontFamily: "Times New Roman, serif",}}>Calibration Methods:</span> {instrument[0]?.calibrationProcedureNo}
                          </span>
                        </TableCell>
                      </TableRow>
                      {(endPressure && startPressure) && (
                        <TableRow>
                          <TableCell style={{fontFamily: "Times New Roman, serif"}}>
                            Pressure (mbar) : 
                            {
                              Number(startPressure) && Number(endPressure)
                                ? ((Number(startPressure) + Number(endPressure)) / 2).toFixed(1) 
                                : "\u00A0"
                            }
                          </TableCell>
                        </TableRow>
                      )}
                    </Table>
                    {masterDataTable()}
                  </Table>
                  <div>
                    <div style={{ textAlign: "left" }}>
                      {/* <div style={{ marginBottom: "5px", marginTop: "10px"}}>
                        <b>DISCIPLINE : </b>
                        {disciplineName} {subGroup || ""}
                      </div> */}
                      <div className="row">
                        <RenderStaticTables
                          tableDisplayStatus={tableDisplayStatus}
                          configuration={configuration}
                          certificateId={certificateId}
                          instrumentId={instrumentId}
                          deletedTableIds={deletedTableIds}
                          tableDivide={tableDivide}
                          calType={calType}
                          showUncertainty={showUncertainty}
                        />
                      </div>
                    </div>
                  </div>
                   {settingList?.["Opinion And Analysis Table"] && settingList?.["Opinion And Analysis Table"] === "true" &&
                    opinionAndAnalysis()}
                  {settingList?.["Decision Rule"] && settingList?.["Decision Rule"] === "true" &&
                    decisonRule()}
                  <div className="row">
                    <div
                      className="col-12"
                      style={{ pageBreakInside: "avoid" }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div
                          style={{
                            flex: "1",
                          }}
                        >
                          <div className="text-start" style={{}}>
                            <pre
                              style={{
                                fontFamily: "Times New Roman, serif",
                                fontSize: "11px",
                                marginBottom: "0px",
                                padding: "0",
                                lineHeight: 1,
                                whiteSpace: "pre-wrap",
                                pageBreakInside: "avoid",
                              }}
                            >
                              <div
                                style={{
                                  border: "1px solid black",
                                  padding: "5px",
                                  marginTop: "5px",
                                }}
                              >
                                <b
                                  style={{ float: "left", fontSize: "11px",fontFamily: "Times New Roman, serif", }}
                                  className="standardUnitTable"
                                >
                                  Remarks :
                                </b>
                                {settingList["Compliance Status"] &&
                                settingList[
                                  "Compliance Status"
                                ].toLowerCase() === "true"
                                  ? `The results ${
                                      complianceStatus == 1 ? "" : "doesn't"
                                    } comply with acceptance criteria\n`
                                  : ""}
                                {calTypeSetting
                                  ? `Reason For Calibration : ${
                                      (
                                        settingList?.[
                                          "CalibrationTypeOptions"
                                        ]?.split(",") || []
                                      )
                                        .map((label, index) =>
                                          index === calibrationReason - 1
                                            ? label
                                            : null
                                        )
                                        .filter(
                                          (label) => label !== null
                                        )?.[0] || ""
                                    }\n`
                                  : ""}
                                {`${
                                  configuration?.remark || ""
                                }\n`}
                                {settingList["amendment"] === "true" && (amendmnetHistory && amendmnetHistory?.length > 0)
                                  ? (
                                    <>
                                      <div style={{marginTop:"4px"}}>
                                      Amendment Certificate No: <b>{certificateNumber}{revisionNumber > 0 ? `/AMD-${revisionNumber}.` : ""}</b>
                                      </div>
                                      <div>
                                     * This is the Amendment certificate of the <b>{certificateNumber}</b> dated <b>{ISendcalibrationDate}</b>, issued on <b>{dateOfIssue ? formatDateByClient(dateOfIssue) : formatDateByClient(approvedDate)}</b>.
                                      </div>
                                      <div>
                                      * Reason for Amendment: 
                                      </div>
                                      &nbsp; {amendmnetHistory}
                                    </>
                                  )
                                  : ""}
                              </div>
                            </pre>
                          </div>
                        </div>
                        {datasheetImages && datasheetImages?.split(",")?.[0] && /\.(jpg|jpeg|png|webp)$/i.test(datasheetImages?.split(",")?.[0]) && (
                        <div style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "stretch",
                          padding: "0px 5px",
                          maxHeight: "115px", 
                          width:"150px",
                          flexDirection:"column"
                        }}>
                          <img src={datasheetImages?.split(",")?.[0] || ""} alt="weighttrect"  style={{ height: "90%", width:"100%" }}  />
                        </div>
                        )}
                        <div
                          style={{
                            textAlignLast: "center",
                            padding: "0px 10px",
                            marginTop: "5px",
                          }}
                        >
                          <QRCode
                            value={`https://nablwp.qci.org.in/CertificateScopenew?x=V33vN1iy0QS4mQv9l3Ljdw==&a=MTAxODc2`}
                            align="center"
                            size={60}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {settingList["lastModified"] &&
                        settingList["lastModified"].toLowerCase() === "true"
                          ? `\nPrint At : ${formatDateByClient(new Date(), true)}`
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div style={{ width: "100%" }} id="header-section"></div>
      </div>
      // </>
    );
    function customerDetailsTable() {
      return (
        <Table className={classes.table} style={{ marginBottom: "3px" }}>
          <TableRow className={classes.row}>
            <TableCell className={classes.addressCell} style={{ width: "15%",fontFamily: "Times New Roman, serif", }}>
              <div>
                <b style={{fontFamily: "Times New Roman, serif",}}>Customer Name</b>
              </div>
            </TableCell>
            <TableCell
              style={{
                width: "85%",
                padding: "3px",
                fontFamily: "Times New Roman, serif",
              }}
            >
              <div>
                <b style={{fontFamily: "Times New Roman, serif",}}>: {clientName}</b>
              </div>
            </TableCell>
          </TableRow>
          <TableRow className={classes.row}>
            <TableCell className={classes.addressCell} style={{ width: "15%",fontFamily: "Times New Roman, serif", }}>
              <div>
                <b style={{fontFamily: "Times New Roman, serif",}}>Address</b>
              </div>
            </TableCell>
            <TableCell
              style={{
                width: "85%",
                padding: "3px",
                fontFamily: "Times New Roman, serif",
              }}
            >
              <div style={{fontFamily: "Times New Roman, serif",}}>: {address}</div>
            </TableCell>
          </TableRow>
        </Table>
      );
    }
    function otherDetails() {
      return (
        <Table
          className={classes.table}
          style={{ fontSize: "11px", marginBottom: "3px" }}
        >
        <TableRow>
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Discipline</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {disciplineName} {subGroup ? `( Group : ${subGroup.replace(/\n/g,' ').replace(/,\s*/g,', ').trim()} )` : ""}
              </TableCell>
            </TableRow>
          </TableCell>
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Issued On </b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none" ,fontFamily: "Times New Roman, serif",}}>
              {dateOfIssue
                  ? formatDateByClient(dateOfIssue)
                  : formatDateByClient(approvedDate)}
              </TableCell>
            </TableRow>
          </TableCell>
        </TableRow>
        <TableRow>
        <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>Job Code No</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {certificateServiceReqNumber}/{jobNumber?.split('/')?.pop()}
                </TableCell>
              </TableRow>
            </TableCell>  
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Calibration Date</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{ISendcalibrationDate}</TableCell>
            </TableRow>
          </TableCell>
        </TableRow>
          <TableRow className={classes.row}>
          <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>Calibration Done</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {location}
                </TableCell>
              </TableRow>
            </TableCell>            
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>Suggested Due Date</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {calibrationFrequency == "-" ? "-" : calibrationFrequency == "Customer Defined" ? "Customer Defined" : calibrationFrequency == "NA" ? "NA" : formatDateByClient(nextDueDate)}
                </TableCell>
              </TableRow>
            </TableCell>
          </TableRow>
          <TableRow>
          <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>CRF No</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {certificateServiceReqNumber}
                </TableCell>
              </TableRow>
            </TableCell>
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>Receipt Date</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {formatDateByClient(receiptDate)}
                </TableCell>
              </TableRow>
            </TableCell>
          </TableRow>
          {/* <TableRow>
          <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                </TableCell>
              </TableRow>
            </TableCell>
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>CRF Date</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {formatDateByClient(dcDate)}
                </TableCell>
              </TableRow>
            </TableCell>
          </TableRow> */}
        </Table>
      );
    }
    function unitCalibrationDetails() {
      return (
        <Table
          className={classes.table}
          style={{ fontSize: "11px", marginBottom: "3px" }}
        >
        <TableRow>
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Detail about UUC</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none", fontFamily: "Times New Roman, serif", }}><b>{requestedName.length > 0 ? requestedName : instrumentName}</b></TableCell>
            </TableRow>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Make / Model</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}> {make && models ? `${make} / ${models}` : `${make}  ${models}`}</TableCell>
            </TableRow>
          </TableCell>
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Range</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{ranges}</TableCell>
            </TableRow>
          </TableCell>
        </TableRow>
          <TableRow className={classes.row}>
            <TableCell className={classes.infoCell} align="center">
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>Id. No. / Sr. No.</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                <b>{DUCID && serialNo ? `${DUCID} / ${serialNo}` : `${DUCID}  ${serialNo}`}</b>
              </TableCell>
            </TableCell>
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>L.C.</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {lc
                    ?.replaceAll("||", ", ")
                    ?.replaceAll("|", " to ")
                    ?.replaceAll("#", " ")}
                </TableCell>
              </TableRow>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>Condition on Receipt</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>{ConOfDuc}</TableCell>
              </TableRow>
            </TableCell>
            {accuracy && (
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>Accuracy / Class</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {accuracyFormat(accuracy)}
                </TableCell>
              </TableRow>
            </TableCell>
            )}
          </TableRow>
          <TableRow>
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>Type</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                {type}
                </TableCell>
              </TableRow>
            </TableCell>
            {depth && (
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>Immersion Depth</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                  {depth}
                </TableCell>
              </TableRow>
            </TableCell>
            )}
          </TableRow>
        <TableRow>
          <TableCell className={classes.infoCell}>
            <TableRow style={{ border: "none", padding: "0px" }}>
              <TableCell
                style={{
                  border: "none",
                  width: "150px",
                  padding: "0px",
                  fontFamily: "Times New Roman, serif",
                }}
              >
                <b>UUC Location</b>
              </TableCell>
              <TableCell style={{ border: "none" }}>:</TableCell>
              <TableCell style={{ border: "none", fontFamily: "Times New Roman, serif", }}>
              {locationOfInstrument ? locationOfInstrument : ""}
              </TableCell>
            </TableRow>
          </TableCell>
          {sensorDia && (
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>Sesnor Dia & Length</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                  {sensorDia}
                </TableCell>
              </TableRow>
            </TableCell>
            )}
          </TableRow>
          <TableRow>
          {parameter && (
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                    fontFamily: "Times New Roman, serif",
                  }}
                >
                  <b>Parameter</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none",fontFamily: "Times New Roman, serif", }}>
                  {parameter}
                </TableCell>
              </TableRow>
            </TableCell>
            )}
          </TableRow>
          {sensorType && (
          <TableRow>
            <TableCell className={classes.infoCell}>
              <TableRow style={{ border: "none", padding: "0px" }}>
                <TableCell
                  style={{
                    border: "none",
                    width: "150px",
                    padding: "0px",
                  }}
                >
                  <b>Sensor Type</b>
                </TableCell>
                <TableCell style={{ border: "none" }}>:</TableCell>
                <TableCell style={{ border: "none" }}>
                  {sensorType}
                </TableCell>
              </TableRow>
            </TableCell>
          </TableRow>
          )}
        </Table>
      );
    }
    function masterDataTable() {
      //Please don't put thead or tbody
      return (
        <div align="center">
          <b>Master Instruments Detail</b>
          <br></br>
          <table
            className="standardUnitTable single-border-table"
            align="center"
          >
            <tr>
              <td>
                <b>Name</b>
              </td>
              <td>
                <b>ID No. / Serial No.</b>
              </td>
              <td>
                <b>Certificate No.</b>
              </td>
              <td>
                <b>Valid Upto</b>
              </td>
              {/* <td>
                <b>Make</b>
              </td>
              <td>
                <b>Model</b>
              </td> */}
              <td>
                <b>Cal By / Accreditation Certificate No.</b>
              </td>
              <td>
                <b>Range</b>
              </td>
            </tr>
            {standardMasterArray.map((row, index) => (
              <tr key={row.name}>
                <td>{row.standardName}</td>
                <td>{row.stId && row.serialNo  ? `${row.stId} / ${row.serialNo}` : `${row.stId} ${row.serialNo}` }</td>
                <td>{row.certificateNumber}</td>
                <td>{moment(row.validUpto).format("DD/MM/YYYY")}</td>
                {/* <td>{row.make}</td>
                <td>{row.model}</td> */}
                <td>{row.traceability}</td>
                <td>{parseRange(row.masterrange)}</td>
              </tr>
            ))}
          </table>
        </div>
      );
    }
    function opinionAndAnalysis() {
      return (
        <div>
          <div style={{ textAlign: "left" }}>
            <b>Opinion And Analysis</b>
          </div>
          <table
            className="standardUnitTable single-border-table"
            align="center"
          >
            <tr>
              <td>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  <div>
                    <span>Accepted - Pass</span>
                  </div>
                  {checkboxOptions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={
                          analysisSelectedOption?.accepted === (item === "✔")
                        }
                        value={item}
                      />
                      <label>{item}</label>
                    </div>
                  ))}
                </div>
              </td>
              <td>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  <div>
                    <span>Calibrated</span>
                  </div>
                  {checkboxOptions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={
                          analysisSelectedOption?.calibrated === (item === "✔")
                        }
                        value={item}
                      />
                      <label>{item}</label>
                    </div>
                  ))}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  <div>
                    <span>Limited Use (Refer - Result)</span>
                  </div>
                  {checkboxOptions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={
                          analysisSelectedOption?.limitedUse === (item === "✔")
                        }
                        value={item}
                      />
                      <label>{item}</label>
                    </div>
                  ))}
                </div>
              </td>
              <td>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  <div>
                    <span>Rejected - Fail</span>
                  </div>
                  {checkboxOptions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={
                          analysisSelectedOption?.rejected === (item === "✔")
                        }
                        value={item}
                      />
                      <label>{item}</label>
                    </div>
                  ))}
                </div>
              </td>
            </tr>
          </table>
        </div>
      );
    }
    function decisonRule() {
      const dr = analysisSelectedOption || {};
      const c = (v) => v == 1;
      const items = [
        "Error is within manufacturer specification or IS Standard or customer specification then it is termed as Pass/Fail.",
        "Error measurement + Uncertainty is within manufacturer specification then it is termed as Pass/Fail.",
        "No Decision Rule or No conformity statement (Accept/Reject)."
      ];
      const flags = [c(dr.decsionRule1), c(dr.decsionRule2), c(dr.decsionRule3)];
      return (
        <div style={{textAlign:"left"}}>
          <b>Decision Rule</b>
          <table className="standardUnitTable single-border-table" align="center">
            {items.map((text, i) => (
              <tr key={i}>
                <td>
                  <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
                    <input type="checkbox" checked={flags[i]} readOnly />
                    <span>{text}</span>
                  </div>
                </td>
              </tr>
            ))}
          </table>
        </div>
      );
    }
  };
  let nonAdminRoleType = userType != 1 && userType != 4;
    
  const showButton = (button) => {
    if (rejectedBy?.[0]) return false;
    if (!roles_ids?.includes(button)) return false;
    let ret =
      calibratedby &&
      calibratedby.length > 0 &&
      (totalReadings != null && totalReadings > 0) &&
      calibratedby[0] !== user[1] &&
      !props.isPrint &&
      status !== -1;

    switch (button) {
      case 3:
        ret =
          ret &&
          approvedby?.[0] &&
          !reviewedBy[0] &&
          ((
            rolesSettins[3]?.name &&
              `${rolesSettins[3]?.name}`.toLocaleLowerCase() !== "false"
              ) &&
            props.rolesInfo?.currentRole?.id == 3);
        break;
      case 4:
        ret =
          ret &&
          approvedby?.[0] &&
          !signedBy[0] &&
          (
            (rolesSettins[4]?.name &&
              `${rolesSettins[4]?.name}`.toLocaleLowerCase() !== "false"
              ) &&
            props.rolesInfo?.currentRole?.id == 4);
        break;
      case 5:
        ret =
          ret &&
          !witnessedBy[0] &&
          ((
            rolesSettins[5]?.name &&
              `${rolesSettins[5]?.name}`.toLocaleLowerCase() !== "false"
              ) &&
            props.rolesInfo?.currentRole?.id == 5);
        break;
      case 1:
        ret =
          ret &&
          !approvedby?.[0] &&
        !reviewedBy[0] &&
        !signedBy[0] &&
        !witnessedBy[0] &&
          !rejectedBy[0] &&
          ((
            rolesSettins[1]?.name &&
              `${rolesSettins[1]?.name}`.toLocaleLowerCase() !== "false"
              ) &&
            props.rolesInfo?.currentRole?.id != 1);
        break;
      case 2:
        ret =
          ret &&
          !approvedby?.[0] &&
          (
            (rolesSettins[2]?.name &&
              `${rolesSettins[2]?.name}`.toLocaleLowerCase() !== "false"
              ) &&
            props.rolesInfo?.currentRole?.id == 2);
        break;
      default:
        ret = false;
        break;
    }

    return ret;
  };

  const renderButtonPair = (button, label, color, status, nonAdminRoleType) => (
    <>
      <Button
        id={`certificate-certificateview_${label.toLowerCase()}btn`}
        variant="contained"
        color={color}
        size="small"
        sx={{ ml: 3 }}
        onClick={() => {
          if (!selectedStandards || selectedStandards == "" || selectedStandards.length == 0) {
            window.alert("Compliance Status is failed.\nMaster Details Not Found.");
            return;
          }
          if (label == "Approve" && settingList["Compliance Status Alert"]?.toLowerCase() == "true" && complianceStatus != 1 ) {
            window.alert("Compliance Status is failed.");
          } else {
           
            ChangeCertificateStatus(status, [id], { settingList, allocatedULRNo, calType });
          }
          if(editAccess?.includes(7) && label == "Approve" && settingList["Compliance Status Alert"]?.toLowerCase() == "true" && complianceStatus != 1){
            ChangeCertificateStatus(status, [id], { settingList, allocatedULRNo, calType });
          }
        }}
      >
        {label}
      </Button>
      {nonAdminRoleType && ( <Button
        id="certificate-certificateview_Rejectbtn"
        variant="contained"
        color="error"
        size="small"
        sx={{ ml: 3 }}
        onClick={() => {
          setModalOpen(true);
        }}
      >
        Reject
      </Button>
      )}
    </>
  );

  const renderAdminRejectButton = () => (
    (showButton(3) || showButton(4) || showButton(5) || showButton(2)) && (
      <Button
        id="certificate-certificateview_Rejectbtn"
        variant="contained"
        color="error"
        size="small"
        sx={{ ml: 3 }}
        onClick={() => {
          setModalOpen(true);
        }}
      >
        Reject
      </Button>
    )
  );

  const ShowRejectModal = () => {
    const [rejectReason, setRejectReason] = useState("");
    return (
      <Modal
        open={modalOpen}
        onClose={(e, r) => {
            handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        size="md"
      >
        <Box sx={modalStyle}>
          <TextField
            id="outlined-basic"
            label="Reason For Rejection"
            value={rejectReason}
            multiline
            maxRows={5}
            rows={5}
            size="small"
            fullWidth
            variant="outlined"
            style={{ marginBottom: "5px" }}
            onChange={(e) => setRejectReason(e.target.value)}
          />
          <Tooltip title="Send Rejection Reason" placement="top-start">
            <Button
              variant="contained"
              color="error"
              size="small"
              sx={{ m: 2 }}
              onClick={() => {
                ChangeCertificateStatus("reject", [id], { calibratedby, instrumentName,certificateNumber, DUCID, rejectionMessage: rejectReason, usercurrentRole: props.rolesInfo?.currentRole?.name, approvedby });
              }}
              disabled={rejectReason === ""}
            >
              Reject
            </Button>
          </Tooltip>
        </Box>
      </Modal>
    );
  };

  return (
    <>
      {!props.isPrint && !props.certificateIds && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Tooltip title="User Guide" placement="top-start">
            <Button
              onClick={() => {
                viewCertificateGuides.drive();
              }}
            >
              <HelpIcon />
            </Button>
          </Tooltip>
        </div>
      )}

      {showMessageScreen ? (
        <div style={{
            height: "100vh", width: "100%", background: "#fff", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column",
          }}
        > <h2>{showMessageScreen}</h2>
          {showMessageScreen.includes("Certificate Is Not Approved.") && (
            <>
              <br />
              <Tooltip
                style={{
                  textTransform: "uppercase",
                  display: "flex",
                  gap: "0px",
                  alignItems: "center",
                }}
                title={
                  JSON.parse(sessionStorage.getItem("historicalTable"))
                    ? `Show Current Data`
                    : `Show Historical Data`
                }
              >
                <Button
                  variant="contained"
                  size="small"
                  sx={{ ml: 1, height: "35px", width: "35px" }}
                  onClick={() => {
                    const currentState = JSON.parse(
                      sessionStorage.getItem("historicalTable")
                    );
                    const newState = !currentState;
                    sessionStorage.setItem(
                      "historicalTable",
                      JSON.stringify(newState)
                    );
                    window.location.reload();
                  }}
                >
                  {JSON.parse(sessionStorage.getItem("historicalTable")) ? (
                    <DataUsageIcon
                      style={{ fontSize: "1.2rem" }}
                    />
                  ) : (
                    <HistoryIcon
                      style={{ fontSize: "1.2rem" }}
                    />
                  )}
                </Button>
              </Tooltip>
              <h3 style={{ color: "red", fontSize: "1.2rem", marginTop: "2rem" }}>Click on History  Button  To Know More Details.</h3>
            </>
        )}
        </div>
      ) :
        <> 
      {paramCertificateId && (
        <Toolbar style={{ padding: "0px", width: "95%", margin: "auto" }}>
          {userType == 3 || !approvedby ? (
            // Show content for userType 3
            <Grid container spacing={2}>
              {/* Elements for userType 3 */}
              {totalReadings > 0 && (
              <Grid item xs={12} textAlign={"right"}>
                <Button
                  id="certificate-certificateviewDownalod"
                  variant="contained"
                  size="small"
                  disabled={!(editAccess?.includes(3) || editAccess?.includes(0))}
                  // sx={{ ml: 3 }}
                  onClick={() => {
                    if(paramMultipleCertificateIdsArray.length > 1) {                      
                      setpdfGenerated(true);
                    }else{
                     generatePDF(printProps);
                    downloadAuditlog();
                    }
                  }}
                >
                  {approvedby ? "Download PDF" : "Download Draft"}
                </Button>
              </Grid>
              )}
            </Grid>
          ) : // For other userTypes
          ((userType === 1 || userType === 4) &&
              approvedby &&
              !props.certificateIds) ||
            (!props.isPrint && approvedby && !props.certificateIds) ? (
            <Grid container spacing={2} align="left">
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Autocomplete
                  disabled={draft}
                  size="small"
                  id="certificate-certificateviewletterhead"
                  options={[
                    { id: 1, label: "With Letter Head" },
                    { id: 2, label: "Without Letter Head" },
                  ]}
                  renderInput={(params) => (
                    <TextField {...params} label="letterHead" />
                  )}
                  onInputChange={(event, newInputValue) => {
                    if (
                      newInputValue === "With Letter Head" ||
                      newInputValue === ""
                    ) {
                      setLetterHead(true);
                      setDraft(false);
                    } else if (newInputValue === "Without Letter Head") {
                      setLetterHead(false);
                    }
                  }}
                />
              </Grid>
              {settingList["letterHeadCompanyType"] && settingList["letterHeadCompanyType"]?.toLowerCase() === "true" && letterHead && (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Autocomplete
                  size="small"
                  options={[
                    { id: 1, label: "Old" },
                    { id: 2, label: "New" },
                  ]}
                  renderInput={(params) => (
                    <TextField {...params} label="Select LetterHead Type" />
                  )}
                  onInputChange={(event, newInputValue) => {
                    if (
                      newInputValue === "Old" ||
                      newInputValue === ""
                    ) {
                      setLetterHeadCompnayType(true);
                    } else if (newInputValue === "New") {
                      setLetterHeadCompnayType(false);
                    }
                  }}
                />
              </Grid>
              )}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Autocomplete
                  size="small"
                  id="certificate-certificateviewelectronicsign"
                  options={[
                    { id: 1, label: "With Electronically Signed" },
                    { id: 3, label: "Signature Image" },
                    { id: 2, label: "Without  Electronically Signed" },
                  ]}
                  renderInput={(params) => (
                    <TextField {...params} label="Electronically Signed" />
                  )}
                  onInputChange={(event, newInputValue) => {
                    if (
                      newInputValue === "With Electronically Signed" ||
                      newInputValue === ""
                    ) {
                      setElectronicSign(true);
                      setSignImg(false);
                    } else if (
                      newInputValue === "Without  Electronically Signed"
                    ) {
                      setElectronicSign(false);
                      setSignImg(false);
                      }
                      else if (
                        newInputValue === "Signature Image"
                      ) {
                      setElectronicSign(false);
                      setSignImg(true);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <Autocomplete
                  size="small"
                  options={
                    letterHead ?
                    [{ id: 1, label: "Scan Copy" },
                    { id: 2, label: "Without Scan Copy" }]
                    :
                    [{ id: 1, label: "With Draft" },
                    { id: 2, label: "Without Draft" }]
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Draft " />
                  )}
                  onInputChange={(event, newInputValue) => {
                    if (
                      newInputValue === "With Draft" ||
                      newInputValue === ""
                    ) {
                      setDraft(true);
                      setLetterHead(false);
                      setScanCopy(false);
                    } else if (newInputValue === "Without Draft") {
                      setDraft(false);
                      setScanCopy(false);
                      // setLetterHead(true)
                    } else if (newInputValue === "Scan Copy") {
                      setDraft(false);
                      setScanCopy(true);
                    }  else if (newInputValue === "Without Scan Copy") {
                      setScanCopy(false);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={3} md={2} lg={2}>
                <Button
                  id="certificate-certificateviewDownalod"
                  variant="contained"
                  size="small"
                  disabled={!(editAccess?.includes(3) || editAccess?.includes(0))}
                  onClick={() => {
                    if(paramMultipleCertificateIdsArray.length > 1) {                      
                      setpdfGenerated(true);
                    }else{
                    generatePDF(printProps);
                    downloadAuditlog();
                    }
                  }}
                >
                  Download PDF
                </Button>
              </Grid>
              {status != 1 && props.rolesInfo?.currentRole?.id == 2 && paramMultipleCertificateIdsArray.length == 1 && (
              <Grid item xs={6} sm={3} md={2} lg={2}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => handleWithdrawApproval([{ "id": certificateId, "clientId": clientID}])}
                >
                  Withdraw Approval
                </Button>
              </Grid>
              )}
            </Grid>
          ) : null}
        </Toolbar>
      )}
      {/* {props.isPrint === true && approvedby && (
        <Grid item xs={2}>
          <Button
            id="certificate-certificateviewDownalod"
            variant="contained"
            size="small"
            // disabled={!(editAccess?.includes(3) || editAccess?.includes(0))}
            onClick={() => {
              if (storedDeviceInfo === "mobile" || storedDeviceInfo === "tablet") {
                alert("To download PDF, please use the desktop site.");
              } else {
                if(paramMultipleCertificateIdsArray.length > 1) {                  
                  setpdfGenerated(true);
                }else{
                generatePDF(printProps);
                }
              }
            }}
          >
            Download PDF
          </Button>
        </Grid>
      )} */}

      <div style={{width: props.isPrint === true ? "85%" : "100%",margin:"auto"}}>
      {printView()}
      </div>

      <Toolbar style={{ padding: "0px", width: "100%" }}>
      {showButton(3) && renderButtonPair(3, 'Review', 'success', 'review',nonAdminRoleType)}
      {showButton(4) && renderButtonPair(4, 'Sign', 'error', 'sign',nonAdminRoleType)}
      {showButton(5) && renderButtonPair(5, 'Witnessed', 'info', 'witness',nonAdminRoleType)}
      {showButton(2) && renderButtonPair(2, 'Approve', 'success', 'approve',nonAdminRoleType)}
      {(userType == 1 || userType == 4) ? renderAdminRejectButton() : showButton(1)}

      
      </Toolbar>
        </>
        }
      {ShowRejectModal()}
      
      {downloadPdfloading && (
        <DownloadPdfLoaderModal
          loading={downloadPdfloading}
          name={"Certificate"}
          abort={true} 
        />
      )}
      {errormodalIsOpen && (
        <ErrorModal
          errormodalIsOpen={errormodalIsOpen}
          closeErrorModal={closeErrorModal}
          errorMessage={errorMessage}
        />
      )}
      <CertificateDownloadPreview
        open={previewOpen}
        onClose={() => {
          setPreviewOpen(false);
          setShowMessageScreen("Session Timed Out.");
        }}
        onDownload={() => {
          generatePDF(printProps);
        }}
        clientId={clientID}
        clientName={clientName}
        address={address}
        instrumentName={requestedName || instrumentName}
        ranges={ranges}
        lc={lc}
        serialNo={serialNo}
        make={make}
        models={models}
        calibrationDate={calibrationDate}
        nextDueDate={nextDueDate}
        calibrationFrequency={calibrationFrequency}
        certificateNumber={certificateNumber}
        ulrNumber={ulrNumber}
      />
    </>
  );
}
